<template>
    <div>
        <v-row class="my-2 mx-4">
			<h1 class="text-left ">Finance Preferences</h1>
		</v-row>
        <v-row justify="center">
            <v-col cols="12" md="8">
                <v-card class="mx-2 pa-3">
                    <v-form @submit.prevent="saveFinancePreferences">
                            <v-checkbox 
                                v-model="preferences.link_fees"
                                label="Link Fees with Finance"
                                hint="Each fee collection will be prompted to select a finance account where the credit entry will be created"
                                persistent-hint
                            >
                            </v-checkbox>
                            <v-checkbox 
                                v-model="preferences.link_inventory"
                                label="Link Inventory with Finance"
                                hint="For each fulfilled GRN, a corresponding entry will be created in the selected finance account"
                                persistent-hint

                            >
                            </v-checkbox>
                            <v-checkbox 
                                v-model="preferences.link_payroll"
                                label="Link Payroll with Finance"
                                hint="For each payslip generated, a corresponding entry will be created in the selected finance account"
                                persistent-hint
                            >
                            </v-checkbox>
                            <div class="mx-4 my-4">
                                <v-btn
                                    class="mr-4"
                                    color="red"
                                    :to="{ name: 'FinanceSettings' }"
                                    rounded
                                    outlined
                                >
                                Cancel
                                </v-btn>
                                <!-- Removed disabled from submit button :disabled="isLoading || !submitForm" -->
                                <v-btn
                                    color="primary"
                                    type="submit"
                                    @click="saveFinancePreferences"
                                    rounded
                                >Submit</v-btn
                                >
                            </div>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
        <!-- snackbar -->
        <v-snackbar v-model="snackbar.visible">
            <span>{{ snackbar.text }}</span>
            <template>
                <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
            </template>
        </v-snackbar>
        
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";

export default {
    name: "FinancePreferences",
    data(){
        return{
            preferences: {
                link_payroll: false,
                link_fees: false,
                link_inventory: false,
            },
            snackbar: {
                visible: false,
                text: "",
            },
        }
    },
    computed:{
        ...mapGetters([
            "currentUser",
            "accessToken",
            "isLoading",
            "currentInstitution",
        ]),

        apiEssentials() {
            return {
                accessToken: this.accessToken,
                setLoading: this.setLoading,
                handleErrorsFunction: this.handleApiErrors,
            };
        },
    },
    methods:{
        ...mapActions(["setLoading"]),
        // handle api errors
        async handleApiErrors(err) {
            this.setLoading(false);
            if (err.response) {
                console.log(err.response);
            } else {
                this.snackbar.text = "Unknown error occurred";
                this.snackbar.visible = true;
            }
        },

        async getFinancePreferences(){
            var url = endpoints.financePreferences + `${this.currentInstitution.id}/`;
            this.preferences = await api.call(this.apiEssentials, url)
        },

        async saveFinancePreferences(){
            var url = endpoints.financePreferences + `${this.currentInstitution.id}/`;
            var put_body = this.preferences;
            var response = await api.call(this.apiEssentials,url,api.Methods.PUT, put_body)
            if(response){
                this.snackbar.text = "Preferences saved successfully.";
                this.snackbar.visible = true;
                let self = this;
                setTimeout(() => {
                    self.$router.push({ name: 'FinanceSettings' });
                }, 1000);
            }
        }
    },
    created(){
        this.getFinancePreferences();
    }
}
</script>
